import {
  AVAILABLE_MARKETS,
  type MarketIsoCode,
} from "@root/tablescape/constants";
import type { LanguageCode } from "@shopify/hydrogen-react/storefront-api-types";

export const isMarketIsoCode = (value: unknown): value is MarketIsoCode => {
  return (
    typeof value === "string" &&
    Object.prototype.hasOwnProperty.call(AVAILABLE_MARKETS, value)
  );
};

export const getShopifyCountry = (): MarketIsoCode | undefined => {
  if (typeof window === "undefined") return undefined;
  const code = window.Shopify?.country;
  return isMarketIsoCode(code) ? code : undefined;
};

export const getShopifyLocale = (): LanguageCode | undefined => {
  if (typeof window === "undefined") return undefined;
  return window.Shopify?.locale;
};

type BrowsingContextSuggestion = {
  confidence: number;
  parts: {
    country: {
      confidence: number;
      handle: string;
      name: string;
      options: {
        [country: string]: string;
      };
    };
    language?: {
      confidence: number;
      handle: string;
      name: string;
      options: {
        [country: string]: string;
      };
    };
  };
};

type BrowsingContextSuggestions = {
  confidence: number;
  detected_values: {
    country: {
      handle: string;
      name: string;
    };
  };
  suggestions: BrowsingContextSuggestion[];
};

export const fetchGeolocationSuggestions = async (): Promise<
  BrowsingContextSuggestions | undefined
> => {
  try {
    const res = await fetch(
      window.Shopify?.routes?.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true" +
        `&country[exclude]=${window.Shopify.country}`
    );

    return await res.json();
  } catch (error) {
    console.error(error);
  }
};
